'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'store';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f54e';
var svgPathData = 'M483.4 224c4.1 0 8.1-.3 12.1-.8l.5-.1 0 32.9 0 128 0 112L80 496l0-112 0-128 0-32.8 .2 0c4 .5 8.1 .8 12.1 .8c20.3 0 38.7-6.8 53.4-18.1c4.3-3.3 8.2-6.9 11.8-10.9c3.6 3.9 7.5 7.6 11.8 10.8C184 217.2 202.5 224 222.7 224c20.3 0 38.7-6.8 53.4-18.1c4.3-3.3 8.2-6.9 11.8-10.9c3.6 3.9 7.5 7.6 11.8 10.8c14.7 11.3 33.2 18.1 53.4 18.1c20.3 0 38.8-6.8 53.4-18.1c4.3-3.3 8.2-6.9 11.8-10.9c3.6 3.9 7.5 7.6 11.8 10.8c14.7 11.3 33.2 18.1 53.4 18.1zM28.3 103.8c-26.5 42-8.2 98.6 35.7 115.3L64 256l0 128 0 120 0 8 8 0 432 0 8 0 0-8 0-120 0-128 0-36.9c43.9-16.7 62.2-73.3 35.6-115.3L480 0 96 0 28.3 103.8zM92.4 208c-3.3 0-6.7-.2-10-.7c-42.3-5.7-64.6-56.7-40.5-94.9L104.7 16l366.7 0 62.8 96.4c24.1 38.2 1.7 89.3-40.7 94.9c-3.3 .4-6.6 .7-10 .7c-21.3 0-40.2-9.3-53.3-23.7l-11.9-13.1-11.8 13.1c-13 14.4-31.9 23.7-53.3 23.7c-21.3 0-40.3-9.3-53.3-23.7l-11.9-13.1L276 184.3c-13 14.4-31.9 23.7-53.3 23.7c-21.3 0-40.3-9.3-53.3-23.7l-11.9-13.1-11.9 13.1c-13 14.4-31.9 23.7-53.3 23.7zM144 256l0-8-16 0 0 8 0 120 0 8 8 0 304 0 8 0 0-8 0-120 0-8-16 0 0 8 0 112-288 0 0-112z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStore = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;